module.exports = __webpack_public_path__ + "img/Frame 5111.dc017d66.jpg";